var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CStyleForm',{attrs:{"current_user":_vm.current_user,"json_styles":_vm.json_styles,"user_styles":_vm.user_styles}}),_vm._v(" "),_c('CStyleManager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }